import React from "react";
import MediaQueryHome from "./MediaQueryHome";

const Page = () => (
    <MediaQueryHome></MediaQueryHome>
);

export default Page;